export default __webpack_public_path__ + "static/media/3.2498b154.jpg";